import { alumni } from "../data/_alumni-list.js";
import { html, utl_ehElements, utl_handleModalClose, utl_renderObjects } from "../base/_utils.js";
import Papa from "papaparse";
import $ from "jquery";
import "slick-slider";

function getAndDisplayEventsData() {
    let calendar_url = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTFsU_fd0L_UvQSrvED8UOGnW5LyJg7RqysdyVe9KFygkWp326cECtU0NW4VBPFI6xZmDWRhQI4_WXb/pub?gid=0&single=true&output=csv";

    return new Promise((resolve, reject) => {
        function init() {
            Papa.parse(calendar_url, {
                download: true,
                header: true,
                comments: "//",
                complete: showInfo,
            });
        }

        window.addEventListener("DOMContentLoaded", init);

        function showInfo(results) {
            let data = results.data;

            // Check to see if item has a button/link
            function checkForBtn(hasBtn, btnText, btnLink) {
                // If it does have a btn, return the html and include the provided link, too
                if (hasBtn) {
                    return html`<br /><a class="btn btn-primary" href="${btnLink}" target="_blank" rel="noopener noreferrer">${btnText}</a>`;
                    // Otherwise, if it doesn't have a btn, don't add any html
                } else return "";
            }

            for (let i = 0; i < data.length; i++) {
                let featured = data[i].featured.toLowerCase();
                if (featured == "yes") {
                    document.getElementById("calendar-list").innerHTML += html`
                        <div class="col d-flex">
                            <div class="event card w-100 d-flex mb-4 shadow">
                                <div class="calendar-tag border border-1 border-top-0 border-start-0 border-end-0 d-flex flex-column">
                                    <p class="month h4 bg-primary text-center text-white px-4 py-3 mb-0">${data[i].month}. ${data[i].day}</p>
                                </div>
                                <div class="event-details p-4">
                                    <p class="fw-bold text-primary mb-0">${data[i].eventName}</p>
                                    <p class="mb-1">${data[i].eventDate}</p>
                                    <p class="mb-1">${data[i].eventTime}</p>
                                    <p class="mb-1">${data[i].eventLocation}</p>
                                    ${checkForBtn(data[i].hasButton, data[i].buttonText, data[i].buttonLink)}
                                </div>
                            </div>
                        </div>
                    `;
                } else {
                    document.getElementById("calendar-list").innerHTML += html`
                        <div class="col d-flex">
                            <div class="hidden-event d-none card w-100 d-flex mb-4 shadow">
                                <div class="calendar-tag border border-1 border-top-0 border-start-0 border-end-0 d-flex flex-column">
                                    <p class="month h4 bg-primary text-center text-white px-4 py-3 mb-0">${data[i].month}. ${data[i].day}</p>
                                </div>
                                <div class="event-details p-4">
                                    <p class="fw-bold text-primary mb-0">${data[i].eventName}</p>
                                    <p class="mb-0">
                                        ${data[i].eventDate},
                                        <span><i>${data[i].eventTime}</i></span>
                                    </p>
                                    <small>${data[i].eventLocation}</small>
                                    ${checkForBtn(data[i].hasButton, data[i].buttonText, data[i].buttonLink)}
                                </div>
                            </div>
                        </div>
                    `;
                }
                resolve();
            }
        }
    });
}

const loadMoreBtn = document.querySelector("#load-more-alumni-events");
const showLessBtn = document.querySelector("#show-less-alumni-events");

document.querySelector(".hidden-event") && loadMoreBtn.classList.remove("d-none");

/* ******************** LOAD MORE CALENDAR EVENTS ******************** */
function loadMore() {
    const events = document.querySelectorAll(".event");
    const hiddenEvents = document.querySelectorAll(".hidden-event");
    const calendarList = document.querySelector("#calendar-list");
    const alumniEventsSection = document.querySelector("#alumni-events");

    document.querySelector(".hidden-event") && loadMoreBtn.classList.remove("d-none");

    calendarList.classList.add("eh-container");
    events.forEach((event) => {
        event.classList.add("eh", "eh-md");
    });
    hiddenEvents.forEach((event) => {
        event.classList.add("eh", "eh-md");
    });

    loadMoreBtn.addEventListener("click", () => {
        hiddenEvents.forEach((hiddenEvent) => {
            hiddenEvent.classList.remove("d-none");
        });
        showLessBtn.classList.remove("d-none");
        loadMoreBtn.classList.add("d-none");
    });

    showLessBtn.addEventListener("click", () => {
        alumniEventsSection.scrollIntoView();
        hiddenEvents.forEach((hiddenEvent) => {
            hiddenEvent.classList.add("d-none");
        });
        showLessBtn.classList.add("d-none");
        loadMoreBtn.classList.remove("d-none");
    });
    utl_ehElements();
}
// Only run loadMore() function once getAndDisplayEventsData() has completed
getAndDisplayEventsData()
    .then(loadMore)
    .then(() => {
        let url = window.location.href;
        let alumniEvents = document.querySelector("#alumni-events");
        setTimeout(() => {
            if (url.includes("#alumni-events")) {
                alumniEvents.scrollIntoView();
            }
        }, 300);
    });

$(".responsive-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    speed: 1000,
    draggable: false,
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
            },
        },

        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ],
});

/* ******************** RENDER ALUMNI CARDS / MODALS ******************** */
utl_renderObjects({
    data: alumni,
    template: (member) => html`
        <!-- ALUMNI CARD -->
        <div class="col mb-4">
            <div class="card border-0">
                <a href="#" data-bs-toggle="modal" data-bs-target="#${member.id}Modal" title="View Bio">
                    <div class="card-img-top">
                        <img src="../${member.image}" loading="lazy" alt="${member.name} headshot" class="img-fluid w-100" />
                    </div>
                    <div class="card-header  eh eh-sm bg-secondary text-center border-0">
                        <p class="h6 card-title mb-0">
                            ${member.name} <br />
                            <span><i class="bi bi-plus-square-fill"></i></span>
                        </p>
                        ${member.title
                            ? html`<hr class="mt-1 mb-0" />
                                  <p class="fw-bold mt-2 mb-0">${member.title}</p>`
                            : ""}
                    </div>
                </a>
            </div>
        </div>
        <!-- ALUMNI MODAL -->
        <div class="modal fade" id="${member.id}Modal" tabindex="-1" aria-labelledby="${member.id}Modal" aria-hidden="true">
            <div class="modal-dialog modal-xl ">
                <div class="modal-content bg-texture-secondary">
                    <div class="modal-header border-0 px-4 pb-1">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body d-flex flex-column align-items-center flex-lg-row align-items-lg-start px-4">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="px-3">
                                    <img src="../${member.image}" alt="${member.name} headshot" class="img-fluid w-100 mb-3 mb-lg-0 me-lg-3" />
                                    <h4 class="fw-bold mb-0 mt-2 text-center">${member.name}</h4>
                                </div>
                            </div>
                            <div class="col-lg-8 mt-4 mt-lg-0">
                                ${member.title
                                    ? html`<h5>${member.title}</h5>
                                          <hr />`
                                    : ""}
                                ${member.bio}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    target: (member) => {
        if (member.section === "leadersOfThePack") {
            return "#leaders-of-the-pack-container";
        } else if (member.section === "distinguished") {
            return "#distinguished-container";
        } else if (member.section === "hof") {
            return "#hof-container";
        }
    },
});

utl_handleModalClose();
